/**
 * Service: proxyUserApi
 */
angular.module('acme.common.service.proxyUserApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('ProxyUserApiService', ['$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      init: function(endpoint) {
        this.service = endpoint + '/customer/users';
        this.permissions.service = this.service + '/permissions';
        this.departments.service = this.service + '/departments';
        this.titles.service = this.service + '/titles';
        return true;
      },
      service: '',
      apiVersion: '',

      search: function(props) {
        var qs,
            q = '',
            av = new ApiVersionFactory();

        if (props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['search', 'page', 'pageSize', 'sortDirection', 'sortField', 'totalItems']
            }
          });
          q = qs.query;
        }

        if (q.indexOf('search=') < 0) {
          q += '&search=';
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/names' + q, version: 'v2' })
        });
      },

      /**
       * Invite users
       * Use commas to separate multiple emails
       *
       * @param emails {String}
       * @returns {*}
       */
      invite: function(emails) {
        return $http({
          method: 'post',
          url: this.service + '/invite',
          headers: {
            'x-acme-emails-invite': emails
          }
        });
      },

      /**
       * Resends confirmation email to user
       *
       * @param id
       * @returns {*}
       */
      resendInvite: function(id) {
        return $http({
          method: 'post',
          url: this.service + '/' + id + '/resendConfirmation'
        });
      },

      /**
       * Gets a user
       *
       * @param userId {Integer}
       * @returns {*}
       */
      view: function (userId) {

        return $http({
          method: 'get',
          url: this.service + '/' + userId
        });

      },

      /**
       * List all users for a tenant
       * Accepts:
       *
       * {
       *   pageSize: Number of entries to return
       *   page:  Which page you are getting
       *   departmentId:  Filter, only return users for this department
       *   roleId:  Filter, only return users with this role
       *   jobTitle:  Filter only return users with this title in their title.
       *   activeOnly: if true then will not return deactivated users.
       * }
       *
       * @returns {*}
       */

      list: function(props) {

        var q = '',
            url = this.service,
            av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'departmentId', 'search', 'role', 'jobTitle', 'activeOnly', 'passwordStatus']
            }
          });
          q = qs.query;
        }

        url = av.init({url: url + q, version: 'v2'});

        return $http({
          method: 'get',
          url: url
        });
      },

    /**
     * Creates a new SSO user
     *
     * Accepts:
     * {
       *   userName: {String}
       *   firstName: {String}
       *   lastName: {String}
       *   title: {String}
       *   email: {String}
       *   phoneNumber: {String}
       *   tenantId: {Integer}
       * }
     * @param props
     * @returns {Promise}
     */
    create: function (props) {

      return $http({
        method: 'post',
        url: this.service,
        data: {
          userName: props.userName,
          password: props.password,
          firstName: props.firstName,
          lastName: props.lastName,
          email: props.email,
          title: props.title,
          phoneNumber: props.phoneNumber,
          tenantId: props.tenantId
        }
      });

    },

      permissions: {
        service: '',

        list: function(props) {
          var q = '';
          
          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'departmentId', 'role', 'jobTitle', 'activeOnly']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service + '/' + props.id,
            data: props.users
          });
        }
      },

      titles: {
        service: '',

        list: function(props) {
          var q = '';
          
          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'departmentId', 'role', 'jobTitle', 'activeOnly']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        }
      },

      departments: {
        service: '',

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service + '/' + props.id,
            data: props.users
          });
        }
      }

    };

}]);